'use strict';
(function() {
    const toggle = document.getElementById('nav-toggle');
    const menu = document.getElementById('nav-menu');
    if (!toggle || !menu) return;
    toggle.addEventListener('click', ()=>{
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', String(!expanded));
        menu.classList.toggle('is-open', !expanded);
    });
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && menu.classList.contains('is-open')) {
            toggle.setAttribute('aria-expanded', 'false');
            menu.classList.remove('is-open');
            toggle.focus();
        }
    });
    // Close when clicking outside nav
    document.addEventListener('click', (e)=>{
        if (!e.target.closest('.site-nav') && menu.classList.contains('is-open')) {
            toggle.setAttribute('aria-expanded', 'false');
            menu.classList.remove('is-open');
        }
    });
    // Close when a nav link is activated (important for in-page navigation)
    menu.querySelectorAll('a').forEach((link)=>{
        link.addEventListener('click', ()=>{
            toggle.setAttribute('aria-expanded', 'false');
            menu.classList.remove('is-open');
        });
    });
})();

//# sourceMappingURL=project-6a0619473eda9b304d5017b8.d8378b5b.js.map
